import React from 'react';
import { Check, X } from 'lucide-react';
import { packages } from '../mock';
import { track } from '../lib/analytics';

const scrollToContact = (packageName) => {
  window.dispatchEvent(new CustomEvent('select-package', { detail: packageName }));
  track('package_selected', { package: packageName });
  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
};

const Packages = () => {
  return (
    <section id="packages" className="py-24 md:py-32 max-w-7xl mx-auto px-6" data-testid="packages-section">
      <div className="text-center max-w-2xl mx-auto mb-16">
        <p className="font-display tracking-[0.35em] text-[#c9a85f] text-sm uppercase mb-5">Investment</p>
        <h2 className="font-display font-bold text-white text-4xl md:text-5xl lg:text-6xl uppercase leading-[1]">
          Business Profile Packages
        </h2>
        <p className="mt-5 text-white/55 leading-relaxed">
          Every project is scoped around your goals, locations and deliverables. Choose the closest starting point and we’ll tailor it with you.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 items-start">
        {packages.map((p) => {
          const featured = p.featured;
          return (
            <div
              key={p.id}
              data-testid={`package-card-${p.id}`}
              className={`relative rounded-2xl p-8 flex flex-col h-full transition-transform duration-300 hover:-translate-y-1 ${
                featured
                  ? 'bg-[#c9a85f] text-black shadow-2xl shadow-[#c9a85f]/20 md:-mt-4'
                  : 'bg-[#111] border border-white/10 text-white'
              }`}
            >
              {featured && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-black text-[#c9a85f] font-display text-[10px] tracking-[0.25em] uppercase px-4 py-1.5 rounded-full border border-[#c9a85f]/40">
                  Most Popular
                </span>
              )}

              <h3
                className={`font-display font-bold text-4xl uppercase mb-8 ${
                  featured ? 'text-black' : 'text-white'
                }`}
              >
                {p.name}
              </h3>

              <ul className="space-y-4 flex-1">
                {p.features.map((f, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <span className="mt-0.5 shrink-0">
                      {f.included ? (
                        <Check size={18} className={featured ? 'text-black' : 'text-[#c9a85f]'} />
                      ) : (
                        <X size={18} className={featured ? 'text-black/40' : 'text-white/30'} />
                      )}
                    </span>
                    <span
                      className={`text-sm leading-snug ${
                        f.included
                          ? featured ? 'text-black/90' : 'text-white/85'
                          : featured ? 'text-black/40 line-through' : 'text-white/35 line-through'
                      }`}
                    >
                      {f.text}
                    </span>
                  </li>
                ))}
              </ul>

              <button
                onClick={() => scrollToContact(p.name)}
                data-testid={`package-cta-${p.id}`}
                className={`mt-10 w-full font-display font-semibold tracking-wide py-3.5 rounded-md transition-colors ${
                  featured
                    ? 'bg-black text-white hover:bg-[#1a1a1a]'
                    : 'bg-[#c9a85f] text-black hover:bg-[#d8b970]'
                }`}
              >
                Get Started
              </button>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Packages;
